import $ from "jquery";
import tooltip from "tooltip";
import support from "support";
import navi from "navi";
import Bacon from "Bacon.plugins";
import epgRecordings from "ohjelmaopas/recordings";
import "modal";
import "error";
import "ajax";
import "coupons";
import "hogan";

import ReactDOM from 'react-dom';
import React from 'react';
import ElisaViihde from 'components/ElisaViihde';
import history from 'browser-history';
import viihdeFooter from "viihde-footer";

$.support.cors = true;

navi.init();

ReactDOM.render(<ElisaViihde />, document.getElementById('spa-root'));

const linkClicks = Bacon.fromBinder(eventSink => {
    $(document.documentElement).on('click', 'a[data-ajax="true"]', eventSink);

    return () => {
        $(document.documentElement).off('click', eventSink);
    };
});

linkClicks.onValue(event => {
        event.preventDefault();
        history.push(event.currentTarget.pathname);
    });

support.init();
tooltip.init();

viihdeFooter.init();
epgRecordings.initQuickRecAction();



// WEBPACK FOOTER //
// ./web/js/bootstrap.js